/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingRecommendation
 */
export interface PendingRecommendation {
    /**
     * 
     * @type {string}
     * @memberof PendingRecommendation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PendingRecommendation
     */
    askEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof PendingRecommendation
     */
    lastAskDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PendingRecommendation
     */
    experienceId?: string;
}

/**
 * Check if a given object implements the PendingRecommendation interface.
 */
export function instanceOfPendingRecommendation(value: object): value is PendingRecommendation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('askEmail' in value) || value['askEmail'] === undefined) return false;
    if (!('lastAskDate' in value) || value['lastAskDate'] === undefined) return false;
    return true;
}

export function PendingRecommendationFromJSON(json: any): PendingRecommendation {
    return PendingRecommendationFromJSONTyped(json, false);
}

export function PendingRecommendationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingRecommendation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'askEmail': json['askEmail'],
        'lastAskDate': (new Date(json['lastAskDate'])),
        'experienceId': json['experienceId'] == null ? undefined : json['experienceId'],
    };
}

export function PendingRecommendationToJSON(value?: PendingRecommendation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'askEmail': value['askEmail'],
        'lastAskDate': ((value['lastAskDate']).toISOString().substring(0,10)),
        'experienceId': value['experienceId'],
    };
}

